import FileInput, { addFiles, matchFileAccept } from './FileInput';

export default FileInput;
export { addFiles, matchFileAccept };
